import { api } from './client';
import type { ReviewDto, ReviewQueueItem, RiskOverrideRequest, SubmitReviewRequest } from '../types/reviews';

export const reviewsApi = {
  queue: () => api.get<ReviewQueueItem[]>('/review-queue').then((r) => r.data),

  list: (callId: number) => api.get<ReviewDto[]>(`/calls/${callId}/reviews`).then((r) => r.data),

  submit: (callId: number, body: SubmitReviewRequest) =>
    api.post<ReviewDto>(`/calls/${callId}/review`, body).then((r) => r.data),

  overrideRisk: (callId: number, body: RiskOverrideRequest) =>
    api.post<void>(`/calls/${callId}/risk-override`, body).then((r) => r.data),

  followUp: (callId: number, value: boolean) =>
    api.post<void>(`/calls/${callId}/follow-up`, { value }).then((r) => r.data),

  trainingCase: (callId: number, value: boolean) =>
    api.post<void>(`/calls/${callId}/training-case`, { value }).then((r) => r.data),
};
